import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../images/circle-info-regular-full.svg'

function MostRecentPriceDate ({
  localMostRecentPriceDate,
  setLocalMostRecentPriceDate
}) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartDateChange = e => {
    setLocalMostRecentPriceDate({
      ...localMostRecentPriceDate,
      startDate: e.target.value
    })
  }

  const handleEndDateChange = e => {
    setLocalMostRecentPriceDate({
      ...localMostRecentPriceDate,
      endDate: e.target.value
    })
  }

  return (
    <div className={styles.mostRecentPriceDateContainer}>
      <div className={styles.inlineLabel}>
        <h1 className={styles.mostRecentPriceDateTitle}>
          Most recent price date
        </h1>
        <Tooltip
          title='The date range of the most recent price record.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Most recent price date help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div className={styles.mostRecentPriceDateInputContainer}>
        <input
          className={styles.mostRecentPriceDateInput}
          type='date'
          name='startDate'
          max={maxDate}
          value={localMostRecentPriceDate.startDate}
          onChange={handleStartDateChange}
          required
        />
        <span className={styles.mostRecentPriceDateLabel}>to</span>
        <input
          className={styles.mostRecentPriceDateInput}
          type='date'
          name='endDate'
          max={maxDate}
          value={localMostRecentPriceDate.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>
    </div>
  )
}

export default MostRecentPriceDate
